var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      ref: "popover",
      staticClass: "erop",
      attrs: {
        placement: "" + (_vm.moreShow ? "bottom-end" : "bottom-start"),
        trigger: "" + (_vm.moreShow ? "hover" : "focus"),
        "visible-arrow": false,
        "popper-class": "tips-con",
      },
      on: {
        "after-leave": _vm.afterLeave,
        show: function ($event) {
          !_vm.moreShow && _vm.focus()
        },
        hide: _vm.blur,
      },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isSearch,
              expression: "!isSearch",
            },
          ],
          staticClass: "mulity-menu-wrap",
          on: { click: _vm.handleVisible },
        },
        [
          _c(
            "div",
            { staticClass: "menu-tab" },
            [
              _c(
                "el-scrollbar",
                {
                  ref: "clickselect",
                  attrs: { "wrap-class": "clickselect-scroll_wrap leftBox" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "menu-list" },
                    _vm._l(_vm.dataSource, function (item) {
                      return _c(
                        "div",
                        {
                          key: item.id,
                          staticClass: "menu-item",
                          class: {
                            opened: item.opened,
                            selected: item.selected,
                          },
                          style: _vm.menuStyle,
                          on: {
                            mouseenter: function ($event) {
                              return _vm.handleShowTooltip($event)
                            },
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.onSelect(item)
                            },
                          },
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                "open-delay": 500,
                                disabled: _vm.toolIsShow,
                                content: item.label,
                                placement: "top-start",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "menu-item-name textOverflow" },
                                [_vm._v(" " + _vm._s(item.label) + " ")]
                              ),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.getSecCount(item),
                                  expression: "getSecCount(item)",
                                },
                              ],
                              staticStyle: { "flex-shrink": "0" },
                            },
                            [_vm._v("(" + _vm._s(_vm.getSecCount(item)) + ")")]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "menu-tab",
              class: { "flex-box": _vm.type !== "area" },
            },
            [
              _c(
                "el-scrollbar",
                {
                  ref: "clickselect",
                  staticClass: "second-menu",
                  attrs: { "wrap-class": "clickselect-scroll_wrap" },
                },
                [
                  _vm.currentSelect
                    ? _c("div", { staticClass: "menu-list menu-flex-list" }, [
                        _c(
                          "div",
                          {
                            staticClass: "menu-select-all",
                            class: { selected: _vm.currentSelect.selected },
                            on: {
                              click: function ($event) {
                                return _vm.onSelectAll(_vm.currentSelect)
                              },
                            },
                          },
                          [_vm._v("全部")]
                        ),
                        _c(
                          "div",
                          { staticClass: "second-menu-item" },
                          _vm._l(
                            _vm.currentSelect.childOption,
                            function (item) {
                              return _c(
                                "div",
                                {
                                  key: item.id,
                                  staticClass: "menu-item",
                                  class: {
                                    opened: item.opened,
                                    selected: item.selected,
                                    "leftBox area-menu-item":
                                      _vm.type === "area",
                                  },
                                  style: _vm.menuStyle,
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.onSelectSecond(item)
                                    },
                                    mouseenter: function ($event) {
                                      return _vm.handleShowTooltip($event)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        "open-delay": 500,
                                        disabled: _vm.toolIsShow,
                                        content: item.label,
                                        placement: "top-start",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "menu-item-name textOverflow",
                                        },
                                        [_vm._v(" " + _vm._s(item.label) + " ")]
                                      ),
                                    ]
                                  ),
                                  _vm.secondSelected(item)
                                    ? _c("i", { staticClass: "el-icon-check" })
                                    : _vm._e(),
                                  _vm.type === "area" && _vm.getSecCount(item)
                                    ? _c("span", [
                                        _vm._v(
                                          "（" +
                                            _vm._s(_vm.getSecCount(item)) +
                                            "）"
                                        ),
                                      ])
                                    : _vm._e(),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _vm.type === "area"
            ? _c(
                "div",
                { staticClass: "menu-tab" },
                [
                  _c(
                    "el-scrollbar",
                    {
                      ref: "clickselect",
                      staticClass: "second-menu",
                      attrs: { "wrap-class": "clickselect-scroll_wrap" },
                    },
                    [
                      _c("div", { staticClass: "menu-list menu-flex-list" }, [
                        _c(
                          "div",
                          {
                            staticClass: "menu-select-all",
                            class: { selected: _vm.threeLvselect.selected },
                            on: {
                              click: function ($event) {
                                return _vm.onSelectAll(_vm.threeLvselect)
                              },
                            },
                          },
                          [_vm._v("全部")]
                        ),
                        _c(
                          "div",
                          { staticClass: "second-menu-item" },
                          _vm._l(
                            _vm.threeLvselect.childOption,
                            function (item) {
                              return _c(
                                "div",
                                {
                                  key: item.label,
                                  staticClass: "menu-item",
                                  class: { selected: item.selected },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onSelectThird(item)
                                    },
                                    mouseenter: function ($event) {
                                      return _vm.handleShowTooltip($event)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        "open-delay": 500,
                                        disabled: _vm.toolIsShow,
                                        content: item.label,
                                        placement: "top-start",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "menu-item-name textOverflow",
                                          style: _vm.menuStyle,
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "textOverflow",
                                              staticStyle: { width: "150px" },
                                            },
                                            [_vm._v(_vm._s(item.label))]
                                          ),
                                          item.selected
                                            ? _c("i", {
                                                staticClass: "el-icon-check",
                                              })
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isSearch,
              expression: "isSearch",
            },
          ],
          staticClass: "mulity-menu-wrap mulity-menu-search",
          on: { click: _vm.handleVisible },
        },
        [
          _c(
            "div",
            { staticClass: "menu-tab flex-box" },
            [
              _c(
                "el-scrollbar",
                {
                  ref: "clickselect",
                  attrs: { "wrap-class": "clickselect-scroll_wrap" },
                },
                [
                  _c("div", { staticClass: "suggestion-text" }, [
                    _vm._v("搜索结果："),
                  ]),
                  _c(
                    "div",
                    { staticClass: "menu-list" },
                    [
                      !_vm.searchResult.length
                        ? _c("div", { staticClass: "no-data" }, [
                            _c("span", [_vm._v("未找到匹配的结果")]),
                          ])
                        : _vm._l(_vm.searchResult, function (item, i) {
                            return _c(
                              "div",
                              {
                                key: i,
                                staticClass: "menu-item",
                                class: { selected: item.data.selected },
                                on: {
                                  click: function ($event) {
                                    return _vm.onSelectThird(item.data)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "menu-item-name textOverflow",
                                    class: ["lv-" + item.lv],
                                    style: _vm.menuStyle,
                                  },
                                  [
                                    _vm._v(" " + _vm._s(item.data.label)),
                                    item.data.selected
                                      ? _c("i", {
                                          staticClass: "el-icon-check",
                                        })
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          }),
                    ],
                    2
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { attrs: { slot: "reference" }, slot: "reference" },
        [
          _vm.moreShow
            ? _c("div", { staticClass: "opc", class: _vm.customClass }, [
                _vm._v("展开"),
              ])
            : _c("tag-input", {
                ref: "tagInput",
                staticClass: "tagInput",
                class: { "error-border": _vm.error },
                attrs: {
                  typeInput: _vm.type,
                  allowEnter: false,
                  placeholder: _vm.placeholder0,
                },
                on: {
                  getAreaVal: _vm.getAreaVal,
                  afterAdd: _vm.afterAdd,
                  getFocus: _vm.getFocus,
                  change: _vm.inputSearch,
                  deleteTag: _vm.handleVisible,
                },
                model: {
                  value: _vm.value,
                  callback: function ($$v) {
                    _vm.value = $$v
                  },
                  expression: "value",
                },
              }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }